export enum MessagesEnum {
  CONFIRM_CAPTION = 'Bank Feeds',
  CONFIRM_ACCEPTED = 'Got it, thanks!'
}
